export const isAuthenticatedSelector = state => state.auth.isAuthenticated;
